import { EKolInvestovaniDruh } from 'services/akcionar/emise/novyIsinSend';

const nastrojKolInvNastrojSelect = [
    {
        value: EKolInvestovaniDruh.AKCIESICAV,
        labelcz: 'ISIN_EMISE_DRUH_NASTROJKOLINV_TYP_AKCIESICAV'
    },
    {
        value: EKolInvestovaniDruh.AKCIEUIF,
        labelcz: 'ISIN_EMISE_DRUH_NASTROJKOLINV_TYP_AKCIEUIF'
    }
];

export default nastrojKolInvNastrojSelect;
